import { render, staticRenderFns } from "./VehicleDetailHeader.vue?vue&type=template&id=041ec777&scoped=true&"
import script from "./VehicleDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./VehicleDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleDetailHeader.vue?vue&type=style&index=0&id=041ec777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041ec777",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCard,VCol,VContainer,VIcon,VImg,VRow})
